import { Ban, CheckCircle, AlertTriangle, RefreshCw, MinusCircle, XCircle, Shield, ShieldOff } from 'lucide-react';

const CARD_STATUS_MAP = {
  A: {
    label: 'Active',
    icon: CheckCircle,
    classes: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300',
  },
  U: {
    label: 'Unactivated',
    icon: MinusCircle,
    classes: 'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-300',
  },
  T: {
    label: 'Temp Blocked',
    icon: Ban,
    classes: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  },
  B: {
    label: 'Blocked',
    icon: Ban,
    classes: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  },
  BLOCKED: {
    label: 'Blocked',
    icon: Ban,
    classes: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  },
  S: {
    label: 'Stolen',
    icon: AlertTriangle,
    classes: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300',
  },
  L: {
    label: 'Lost',
    icon: AlertTriangle,
    classes: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300',
  },
  F: {
    label: 'Fraud Attempt',
    icon: ShieldOff,
    classes: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  },
  R: {
    label: 'Restricted',
    icon: Shield,
    classes: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300',
  },
  C: {
    label: 'Closed',
    icon: XCircle,
    classes: 'bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-300',
  },
  Q: {
    label: 'Quit',
    icon: XCircle,
    classes: 'bg-gray-100 text-gray-700 dark:bg-gray-700/50 dark:text-gray-300',
  },
};

export const getCardStatusBadge = (statusCode) => {
  const normalizedStatus = (statusCode || '').toString().toUpperCase();

  return CARD_STATUS_MAP[normalizedStatus] || {
    label: statusCode || 'Unknown',
    icon: Ban,
    classes: 'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-300',
  };
};

// Returns true if the card is closed/quit — user can only download the closure letter
export const isCardClosed = (statusCode) => {
  const normalized = (statusCode || '').toString().toUpperCase();
  return normalized === 'C' || normalized === 'Q';
};

